import { useMemo } from 'react';

import { useAppSelector } from 'shared/lib';

import { getCommonMplAnalyticsParams } from 'entities/analytics';
import { useAnalyticsProductType } from 'entities/creditForm/lib';
import { calcIdSelector } from 'entities/offers';
import { useCurrentScenarioCalcId, useCurrentScenarioCategories, useCurrentScenarioStep } from 'entities/scenario';

import { selectAnalyticsSearchOutput } from '../model';

export const useCommonMplAnalyticsParams = () => {
  const { category, subCategory } = useCurrentScenarioCategories();
  const scenario = useCurrentScenarioStep();
  const scenarioCalcId = useCurrentScenarioCalcId();
  const rankingCalcId = useAppSelector(calcIdSelector);
  const filter = useAnalyticsProductType();
  const searchOutput = useAppSelector(selectAnalyticsSearchOutput);
  return useMemo(
    () =>
      getCommonMplAnalyticsParams({
        category,
        subCategory,
        scenario,
        scenarioCalcId,
        rankingCalcId,
        filter,
        searchOutput,
      }),
    [category, subCategory, scenario, scenarioCalcId, rankingCalcId, filter, searchOutput],
  );
};
